import { fetchAuthSession } from "@aws-amplify/core";
import { LambdaClient, InvokeCommand, InvokeCommandInput } from "@aws-sdk/client-lambda";
import { Buffer } from "buffer";
import { Option, FieldContinuationDataForResolver, FieldTemplateForResolver, FormTemplateForResolver } from "db/definitions";

interface TemplateParserResponse {
	templateJson?: TemplateJsonDocument;
	warnings: string[];
	error?: string;
}

interface TemplateJsonDocument {
	type: string;
	v: number;
	formTemplates: FormTemplateForResolver[];
	fieldTemplates: FieldTemplateForResolver[];
	options: Option[];
	continuationDatas: FieldContinuationDataForResolver[];
}

export async function parseTemplate(file: File): Promise<TemplateParserResponse | null> {
	try {
		const { credentials } = await fetchAuthSession();
		const lambda = new LambdaClient({ region: "us-west-1", credentials });

		const arrayBuffer = await file.arrayBuffer();
		const base64 = Buffer.from(arrayBuffer).toString("base64");

		const payload = {
			dotxBase64: base64,
			fileName: file.name,
		};

		const env = import.meta.env.VITE_APP_ENV !== "production" ? "staging" : "production";

		const invokeCommandInput: InvokeCommandInput = {
			FunctionName: `TemplateParser-${env}`,
			InvocationType: "RequestResponse",
			Payload: Buffer.from(JSON.stringify(payload)),
		};

		const command = new InvokeCommand(invokeCommandInput);
		const response = await lambda.send(command);

		return JSON.parse(new TextDecoder().decode(response.Payload!)) as TemplateParserResponse;
	} catch (err) {
		console.error("ERROR PARSING TEMPLATE", err);
		return null;
	}
}
